/**
 * ChannelsChoiceListContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled channels choice list container.
 */
const ChannelsChoiceListContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: ${60 * Screen.widthRatio}px;
  & > *:not(:last-child) {
    margin-right: ${60 * Screen.widthRatio}px;
  }
`;

export default ChannelsChoiceListContainer;
